import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Sidebar from './Sidebar';
import Header from './Header';
import { devices } from 'styles/devices';
import { colors } from 'styles/colors';

const SidebarTemplate = ({ children, navigation }) => {
   const [active, setActive] = useState(false);

   return (
      <StyledWrapperTemplate>
         <Sidebar active={active} navigation={navigation} />
         <InnerWrapper>
            <Header handleBurgerClick={(active) => setActive(active)} active={active} />
            <Main>{children}</Main>
         </InnerWrapper>
      </StyledWrapperTemplate>
   );
};

SidebarTemplate.propTypes = {
   children: PropTypes.node.isRequired,
   navigation: PropTypes.string.isRequired
};

const StyledWrapperTemplate = styled.div`
   width: 100%;
   padding: 20px;

   ${devices.tabletL} {
      padding: 20px 60px 20px 60px;
   }

   ${devices.tabletXL} {
      display: flex;
      padding: 0 100px 0 0;
   }
`;

const InnerWrapper = styled.div`
   position: relative;
   background: ${colors.white};
   width: 100%;

   ${devices.tabletXL} {
      padding: 20px 0 20px 80px;
   }

   ${devices.desktop} {
      padding: 38px 0 38px 100px;
   }
`;

const Main = styled.main`
   position: relative;
   ${devices.desktopHD} {
      margin-top: 40px;
   }
`;

export default SidebarTemplate;
